(() => {
  const quantity = document.getElementById('quantity');
  if (quantity) {
    const row = quantity.closest('[data-unit-cents]');
    const unit = Number(row?.dataset.unitCents || 0);
    const total = document.getElementById('total');
    const update = (v) => {
      const n = Math.min(99, Math.max(1, Number(v) || 1));
      quantity.value = String(n);
      total.textContent = new Intl.NumberFormat('en-AU', {style:'currency', currency:'AUD'}).format(n * unit / 100) + ' AUD';
    };
    quantity.addEventListener('input', () => { if (quantity.value) update(quantity.value); });
    document.getElementById('decrease')?.addEventListener('click', () => update(Number(quantity.value) - 1));
    document.getElementById('increase')?.addEventListener('click', () => update(Number(quantity.value) + 1));
  }
  document.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
    const photo = document.getElementById('product-photo');
    photo.src = button.dataset.image;
    photo.alt = button.dataset.alt;
    document.querySelectorAll('[data-image]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  }));
})();
